import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';

import {ButtonNew, ButtonSync} from "../../../components/buttons/buttonsActions";
import TypeProductList from "./_list";
import TypeProductForm from "./_form";
import {showToastCustom} from "../../../components/toast/customToast";
import {error, success, updateMsg} from "../../../components/i18n/i18n";
import {showLoader} from "../../../components/loader/loader";
import {typeProductService} from "../../../jwt/_services/promotions/typeProductService";
import {
    clearState,
    setApp,
    setCategory,
    setLoading,
    setUdn,
    setViewMode
} from "../../../redux/actions/generalActions/mainActions";
import {setForm} from "../../../redux/actions/generalActions/formActions";
import { clearState as clearListState } from "../../../redux/actions/generalActions/listActions";
import {connect} from "react-redux";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

const TypeProduct = (props) => {
    const { loading } = props.mainProps

    // Modo de vista: LIST, FORM

    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);
    },[]);

    const syncFirebase = () => {
        props.setLoading(true);
        typeProductService.syncFirebase()
            .then(_ => {
                props.setLoading(false);
                showToastCustom(success, updateMsg);
            })
            .catch(errorMessage => {
                props.setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    const createItem = () => {
        props.setForm()
        ModalFormContainer(TypeProductForm, {data: null, Form : TypeProductForm})
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        <div className="ml-auto paddingAdd">
                            <ButtonSync onClick={syncFirebase} />
                            <ButtonNew onClick={createItem} />
                        </div>
                    </div>
                </Col>
            </Row>
                <Row>
                    <Col md="12">
                        <TypeProductList />
                    </Col>
                </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setForm,
    setApp,
    setCategory,
    setViewMode,
    setLoading,
    clearListState
});

export default connect(mapStateToProps, mapActionsToProps)(TypeProduct)
